module.exports = __webpack_public_path__ + "media/images/bg-shape-blue-c2da5f4a732462c70306f186d7857461.png";